var Backbone = require('backbone'),
    Word = require('./../../positionalTextModels/textAreaModels/word');

// maybe a base for these collections ....

module.exports = Backbone.Collection.extend({

    model: Word

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/pgPositionalTextModel/words.js
 ** module id = 353
 ** module chunks = 0
 **/